import { render, staticRenderFns } from "./IpsTab.vue?vue&type=template&id=980a0d60&scoped=true&"
import script from "./IpsTab.vue?vue&type=script&lang=js&"
export * from "./IpsTab.vue?vue&type=script&lang=js&"
import style0 from "./IpsTab.vue?vue&type=style&index=0&id=980a0d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a0d60",
  null
  
)

export default component.exports